<template>
	<div class="flex flex-wrap h-full">
		<div v-for="(tag, index) in tags" :key="index">
			<TagIconItem :tag="tag" :selected-tag-type="value" @update:selected-tag-type="$emit('input', $event)" />
		</div>
	</div>
</template>

<script>
import TagIconItem from './TagIconItem'
import { getTagsBySportType } from '~/assets/util/helpers/tags'

export default {
	components: { TagIconItem },
	props: {
		value: {
			type: String,
			default: 'good'
		},
		sportType: {
			type: String,
			default: ''
		}
	},
	data: () => ({ }),
	computed: {
		tags () {
			return this.localizeTags(getTagsBySportType(this.sportType))
		}
	},
	methods: {
		localizeTags (tags) {
			return tags.map((el, index) => {
				if (index <= 3) {
					el.name = this.$tc(`tagNames.default.${index}`)
				} else {
					el.name = this.$tc(`tagNames.${this.sportType}.${el.type}`)
				}
				return el
			})
		}
	}
}
</script>
